export default __webpack_public_path__ + "static/media/search.6d70b94e.svg";